import React, { useEffect, useState } from 'react'
import { PokerApi } from 'mvppoker-portal-common/api'
import { useNavigate } from '../navigation'
import { PrepareGameVideoPageView } from './PrepareGameVideoPageView'
import PermissionsService from './PermissionsService'
import { usePreferredCamera } from '../../state/hooks/AppConfigHooks'
import LoadingModal from '../../Views/modals/LoadingModal/LoadingModal'
import { useApi, handleError } from '../../utils/useApi'
import { useActiveGame } from '../../state/hooks/ActiveGameHooks'

export default () =>
{
	const { preferredCamera, setPreferredCamera } = usePreferredCamera()
	const pokerApi = useApi(PokerApi)
	const game = useActiveGame()!

	const goToLobby = useNavigate('lobby')
	const goToGame = useNavigate('game')

	const [hasPermissions, setHasPermissions] = useState(false)
	const [cameraId, setCameraId] = useState<string | undefined>(preferredCamera)
	
	const clickCheckPermissions = async () : Promise<boolean> => {
		const hadPermissions = hasPermissions
		await PermissionsService.HasAudioVideoPermissions()
		const audioEnabled = await PermissionsService.HasAudioPermissions()
		const videoEnabled = await PermissionsService.HasVideoPermissions()
		if (!audioEnabled){
			if (!videoEnabled){
				alert('You need to allow access to your Camera and Microphone')
			}else{
				alert('You need to allow access to your Microphone')
			}
			setHasPermissions(false)
			return false
		}
		if (!videoEnabled){
			alert('You need to allow access to your Camera')
			setHasPermissions(false)
			return false
		}
		if (!hadPermissions) {
			setHasPermissions(true)
			window.location.reload()
		}
		return true
	}
	const clickSelectCamera = (name: string) => {
		setCameraId(name)
		setPreferredCamera(name)
	}
	const clickBack = () => {
		goToLobby({ replace: true })
	}
	const enterRoom = async () => {

		const alertCallback = LoadingModal.Show({ text: 'Entering\n\nPlease wait...' })

		pokerApi
		.pokerRoomsEnter(game.id)
		.then(() => {
			alertCallback()
			goToGame({ replace: true })
		})
		.catch(handleError)
	}
	const clickContinue = async () => {
		const enabled = await clickCheckPermissions()
		if (!enabled){
			return
		}

		if (cameraId){
			enterRoom()
		}
	}

	const runChecks = async () =>
	{
		const enabled = await PermissionsService.HasAudioVideoPermissions()
		setHasPermissions(enabled)
	}
	useEffect(() => {
		runChecks()
	}, [])

	return <PrepareGameVideoPageView 
		hasPermissions={hasPermissions}
		isCameraSet={cameraId !== undefined}

		clickCheckPermissions={clickCheckPermissions}
		clickSelectCamera={clickSelectCamera}
		clickContinue={clickContinue}
		clickBack={clickBack}
	/>
}
